var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:({ '--chrome': _vm.chromeHeight + 'px' })},[_c('h1',{staticClass:"visually-hidden"},[_vm._v("Arne Reckhaus aus Garbsen – Solution Architect & Lead Developer in der Region Hannover")]),_c('ServiceGlobe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }